import { Component, OnDestroy, OnInit, forwardRef, DoCheck, Input, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonDataService } from '../../../_infrastructure/CommonData/CommonDataService';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { PreFilledProperty } from '../../../_infrastructure/Models/pre-filled-property.interface';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import DateHelpers from '../../../_infrastructure/DateHelpers';

@Component({
  selector: 'sender-identification-pre-stage',
  templateUrl: './sender-identification-pre-stage.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => SenderIdentificationPreStageComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class SenderIdentificationPreStageComponent implements OnInit, OnDestroy, OnChanges,AfterViewInit{


  // Declaramos o cardData como get + set em vez de variável simples pois precisamos abaixo de agarrar lógica ao momento
  //  de atualização do cardData ( evita o ngDoCheck ou ngOnChanges ou afins )
  @Input() model: models.SenderIdentificationVM = {} as models.SenderIdentificationVM;
  @Input() qualification: models.SenderQualificationVM = {} as models.SenderQualificationVM;
  @Input() dropdowns: models.WorkflowDropdownsVM;
  public  isEditable: boolean;
  public mainSubscription: Subscription = new Subscription();
  public isCommonDataLoaded: boolean = false;
  public  documentTypes: models.DimensionVM[];
  public maritalStatus: models.Options[];
  public genders: models.DimensionVM[];
  public yesNo: models.DimensionVM[];

  private isFirstChange: boolean = true;
  public preFilledProperties: PreFilledProperty[] = [];
  public maxDate: Date = new Date();

  constructor(private commonDataService: CommonDataService) {
    const domains = [
      DomainCodes.yesNo,
      DomainCodes.genders,
      DomainCodes.martialStatus,
      DomainCodes.identificationType
    ];

    this.mainSubscription.add(
      this.commonDataService.getDomains(domains).subscribe(
        (results: models.DomainVM[]) => {
          this.yesNo = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.yesNo).dimensions;
          this.genders = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.genders).dimensions;
          this.documentTypes = results.find((el: models.DomainVM) => el.domainCode == DomainCodes.identificationType).dimensions;
          this.isCommonDataLoaded = true;
        }
      )
    );
  }
    ngAfterViewInit(): void {

        this.maritalStatus = this.dropdowns?.options
          .filter(el => el.dropdown === "dropListMaritalStatus");
      
    }

  ngOnInit(): void {
    this.isEditable = !this.model.notEditable;


  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isFirstChange && !!this.model) {
      this.isFirstChange = false;
      this.preFilledProperties.push({ name: "name", preFilledValue: this.model.name, hasValue: isNotNullOrUndefinedOrEmpty(this.model.name) });
      this.preFilledProperties.push({ name: "dateOfBirth", preFilledValue: this.model.dateOfBirth, hasValue: !isNullOrUndefined(this.model.dateOfBirth) });
      this.preFilledProperties.push({ name: "hasNacPT", preFilledValue: this.model.hasNacPT, hasValue: isNotNullOrUndefinedOrEmpty(this.model.hasNacPT) });
      if (this.model.hasNacPT?.toString() == 'true') {
        this.model.hasNIFPT = true;
      }

      //As per requirement hasNIFPT is always true
      this.model.hasNIFPT = true;
      this.preFilledProperties.push({ name: "hasNIFPT", preFilledValue: this.model.hasNIFPT, hasValue: isNotNullOrUndefinedOrEmpty(this.model.hasNIFPT) });
      
      this.preFilledProperties.push({ name: "NIF", preFilledValue: this.model.NIF, hasValue: isNotNullOrUndefinedOrEmpty(this.model.NIF) });
      this.preFilledProperties.push({ name: "gender", preFilledValue: this.model.gender, hasValue: isNotNullOrUndefinedOrEmpty(this.model.gender) });
      this.preFilledProperties.push({ name: "civilState", preFilledValue: this.model.gender, hasValue: isNotNullOrUndefinedOrEmpty(this.model.gender) });
      this.preFilledProperties.push(
        {
          name: "identificationNumberFirst",
          preFilledValue: this.model.identificationNumberFirst,
          hasValue: isNotNullOrUndefinedOrEmpty(this.model.identificationNumberFirst)
        });
      this.preFilledProperties.push(
        {
          name: "identificationNumberLast",
          preFilledValue: this.model.identificationNumberLast,
          hasValue: isNotNullOrUndefinedOrEmpty(this.model.identificationNumberLast)
        });
      this.preFilledProperties.push(
        {
          name: "identificationDocumentType",
          preFilledValue: this.model.identificationDocumentType,
          hasValue: isNotNullOrUndefinedOrEmpty(this.model.identificationDocumentType)
        });
    }


  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }

  public hasPortugueseNationalityChange(hasNacPT: boolean) {
    if (hasNacPT.toString() == 'true') {
      this.model.hasNIFPT = true;
      this.model.identificationDocumentType = "B";
    }
    else {
      //this.model.hasNIFPT = null;
      this.model.identificationDocumentType = "P";
    }
  }
  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.model[event.target.name]).toISOString().split('T')[0];
    DateHelpers.onDateChange(event, dp, object);
  }

}
